import { useState, useEffect } from 'react';

const useThinkingDots = (active: boolean, intervalMs = 500): string => {
  const [dots, setDots] = useState(0);

  useEffect(() => {
    if (!active) return;

    const interval = setInterval((): void => {
      setDots((d) => (d + 1) % 4);
    }, intervalMs);
    return (): void => clearInterval(interval);
  }, [active, intervalMs]);

  return '.'.repeat(dots);
};

export default useThinkingDots;
